import {applySnapshot, types as t,} from 'mobx-state-tree';

export const initialAuthStore = {
  token: null,
  refresh: null,
  id: null,
  role: null,
  data: null,
};

export const AuthStore = t
  .model({
    token: t.maybeNull(t.string),
    refresh: t.maybeNull(t.string),
    id: t.maybeNull(t.string),
    role: t.maybeNull(t.string),
    data: t.maybeNull(t.model({
      firstName: t.string,
      lastName: t.string,
    })),
  })
  .views((self => ({
    get hasAuthToken() {
      return !!self.token;
    },
    get hasRole() {
      return !!self.role;
    },
  })))
  .actions((self) => ({
    clearState: () => {
      applySnapshot(self, initialAuthStore);
    },
    setTokenAndId(token: string | null, id: string | null) {
      self.token = token;
      self.id = id;
    },
    setRoleAndData(role: string | null, data: { firstName: string, lastName: string }) {
      self.role = role;
      self.data = data;
    },
  }));
